import React, { useCallback, useMemo } from "react";
import { Pressable, useWindowDimensions, View } from "react-native";
import { useI18nMessage } from "@lookiero/i18n-react";
import { AspectRatioView, theme } from "@lookiero/sty-psp-ui";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { AnimatedChecked } from "../../../../atom/animatedChecked/AnimatedChecked";
import { Button } from "../../../../atom/button/Button";
import { useAnswerForId } from "../../behaviours/useAnswers";
import { useAnswersValidation } from "../../behaviours/useAnswersValidation";
import { QuestionItemState, useQuestionItemState } from "../../behaviours/useQuestionItemState";
import { style as buttonWithIconQuestionItemStyle } from "./ButtonWithIconQuestionItem.style";
const ICON_SIZE = {
    [Tradename.LOOKIERO]: 24,
    [Tradename.OUTFITTERY]: 32,
};
const ICON = {
    ["quiz.icon.thumbs_down_dislike"]: "thumbs_down_dislike",
    ["style_profile.icon.thumbs_down_dislike"]: "thumbs_down_dislike",
    ["quiz.icon.curious"]: "curious",
    ["style_profile.icon.curious"]: "curious",
    ["quiz.icon.inspiration"]: "inspiration",
    ["style_profile.icon.inspiration"]: "inspiration",
    ["quiz.icon.stylist"]: "stylist",
    ["style_profile.icon.stylist"]: "stylist",
    ["quiz.icon.advice"]: "advice",
    ["style_profile.icon.advice"]: "advice",
    ["quiz.icon.workwear"]: "workwear",
    ["style_profile.icon.workwear"]: "workwear",
    ["quiz.icon.time"]: "time",
    ["style_profile.icon.time"]: "time",
};
const ButtonWithIconQuestionItem = ({ domain, segment, question, questionParentId, tradename, }) => {
    const { space3, space6 } = theme();
    const style = useMemo(() => buttonWithIconQuestionItemStyle(), []);
    const titleText = useI18nMessage({
        domain,
        id: question.translationKey,
        values: { segment: segment.toLowerCase() },
    });
    const aspectRatio = question.metadata.aspectRatio || 5 / 4;
    const { answer, onChange } = useAnswerForId({ id: questionParentId });
    const selectedAnswer = answer && answer.find((id) => id === question.id);
    const { validateMaxAnswers } = useAnswersValidation();
    const state = useQuestionItemState({ questionParentId, question });
    const handleOnChange = useCallback(() => {
        onChange({ questionId: question.id, answer: selectedAnswer ? undefined : question.id });
        validateMaxAnswers();
    }, [onChange, question.id, selectedAnswer, validateMaxAnswers]);
    const checked = state === QuestionItemState.SELECTED;
    const icon = ICON[question.metadata.icon];
    const size = ICON_SIZE[tradename];
    const { width } = useWindowDimensions();
    const gapForScreenSize = width < 600 || (width > 840 && width < 1024) ? space3 : space6;
    return (React.createElement(View, { style: style.container, testID: "button-with-icon-question-item" },
        React.createElement(AspectRatioView, { aspectRatio: aspectRatio, style: style.aspectRatioView },
            React.createElement(Button, { checked: checked, component: Pressable, icon: icon, iconSize: size, style: { button: [style.button, { gap: gapForScreenSize }], icon: style.icon, text: style.text }, testID: question.id, title: titleText, onPress: handleOnChange },
                React.createElement(AnimatedChecked, { checked: checked })))));
};
export { ButtonWithIconQuestionItem };
